import { setLocalNavigationOverride } from '../hooks/useBatonConnection';
import { logHomeNavBreadcrumb } from './homeNavigationDiagnostics';

export function performAppHomeNavigation(navigate, viewHandler) {
  logHomeNavBreadcrumb('click', { source: 'nav' });
  setLocalNavigationOverride();
  navigate('/app');
  logHomeNavBreadcrumb('route', { source: 'nav' });
  viewHandler.navigate('home', {});
}
